@if (showTable) {
    <snelstart-ui-table [config]="tableConfig">

        <snelstart-ui-table-col columnType="string" name="label" width="400px">
            <snelstart-ui-table-col-header>
                <div *ngIf="this.dataService.naamAangever && (!this.dataService.naamPartner || this.dataService.naamPartner === 'partner')"
                     style="font-size: 13px; color: #00200b ">
                    {{ this.dataService.naamAangever }}
                </div>
                <div *ngIf="this.dataService.naamPartner && this.dataService.naamPartner !== 'partner'"
                     style="font-size: 13px; color: #00200b ">
                    {{ this.dataService.naamAangever }} & {{ this.dataService.naamPartner }}
                </div>
            </snelstart-ui-table-col-header>

            <snelstart-ui-table-expanded-row>
                <div *ngFor="let option of options; let i = index;">
                    <div *ngFor="let subOnderdeel of option.subonderdelen!; let j = index;">
                        <div *ngIf="subOnderdeel.visible">
                            <snelstart-ui-button
                                    (click)="navigateToSubPage(subOnderdeel)" class="ps-5" icon="chevron-right"
                                    type="link"
                            >
                                <div [ngStyle]="subOnderdeel.pageMapping === activePage ? {'color': '#0073dd', 'font-weight': 'bold'} : {}">
                                    {{ subOnderdeel.label }}
                                </div>
                            </snelstart-ui-button>

                        </div>
                    </div>
                </div>
            </snelstart-ui-table-expanded-row>

        </snelstart-ui-table-col>

        <snelstart-ui-table-col [showFilter]="false" [showSort]="false" columnType="currency" name="tekst"
                                width="200px">
            <snelstart-ui-table-col-header></snelstart-ui-table-col-header>

            <snelstart-ui-table-col-data>
                <ng-template let-record="record">
                    <ng-container>
                        <div *ngIf="(berekening.box1 && berekening.box1.opbouwInkomen && berekening.box1.opbouwInkomen.winstUitOnderneming !== undefined) ||
                                    (berekening.partnerBerekening && berekening.partnerBerekening.box1 &&
                                    berekening.partnerBerekening.box1.opbouwInkomen && berekening.partnerBerekening.box1.opbouwInkomen.winstUitOnderneming !== undefined)">
                            <a *ngIf="record.value === 200">Belastbare winst:</a>
                        </div>
                    </ng-container>
                    <ng-container>
                        <div *ngIf="(berekening.box1 && berekening.box1.opbouwInkomen && berekening.box1.opbouwInkomen.belastbaarloon !== undefined) ||
                                    (berekening.partnerBerekening && berekening.partnerBerekening.box1 &&
                                    berekening.partnerBerekening.box1.opbouwInkomen && berekening.partnerBerekening?.box1?.opbouwInkomen?.belastbaarloon !== undefined)">
                            <a *ngIf="record.value === 300">Belastbaar loon:</a>
                        </div>
                    </ng-container>
                    <ng-container>
                        <div *ngIf="(berekening.box1 && berekening.box1.opbouwInkomen && berekening.box1.opbouwInkomen?.resultaatUitOverigeWerkzaamheden !== undefined) ||
                                    (berekening.partnerBerekening && berekening.partnerBerekening.box1 &&
                                    berekening.partnerBerekening.box1.opbouwInkomen && berekening.partnerBerekening.box1.opbouwInkomen.resultaatUitOverigeWerkzaamheden !== undefined) ||
                                    (berekening.box1 && berekening.box1.opbouwInkomen && berekening.box1.opbouwInkomen.periodiekeUitkeringen !== undefined) ||
                                    (berekening.partnerBerekening && berekening.partnerBerekening.box1 &&
                                    berekening.partnerBerekening.box1.opbouwInkomen && berekening.partnerBerekening.box1.opbouwInkomen.periodiekeUitkeringen !== undefined)">
                            <a *ngIf="record.value === 400">Overig inkomen:</a>
                        </div>
                    </ng-container>
                    <ng-container>
                        <div *ngIf="(berekening.box1 && berekening.box1.opbouwInkomen && berekening.box1.opbouwInkomen.saldoEigenWoning !== undefined) ||
                                    (berekening.partnerBerekening && berekening.partnerBerekening.box1 &&
                                    berekening.partnerBerekening.box1.opbouwInkomen && berekening.partnerBerekening.box1.opbouwInkomen?.saldoEigenWoning !== undefined)">
                            <a *ngIf="record.value === 500">Inkomsten eigen woning:</a>
                        </div>
                    </ng-container>
                    <ng-container>
                        <div *ngIf="(berekening.box1 && berekening.box1.opbouwInkomen && berekening.box1.opbouwInkomen.uitgavenVoorInkomensvoorzieningen !== undefined) ||
                                    (berekening.partnerBerekening && berekening.partnerBerekening.box1 &&
                                    berekening.partnerBerekening.box1.opbouwInkomen && berekening.partnerBerekening.box1.opbouwInkomen.uitgavenVoorInkomensvoorzieningen !== undefined) ||
                                    (berekening.box1 && berekening.box1.opbouwInkomen && berekening.box1.opbouwInkomen.negatieveUitgavenVoorInkomensvoorzieningen !== undefined) ||
                                    (berekening.partnerBerekening && berekening.partnerBerekening.box1 &&
                                    berekening.partnerBerekening.box1.opbouwInkomen && berekening.partnerBerekening.box1.opbouwInkomen?.negatieveUitgavenVoorInkomensvoorzieningen !== undefined)">
                            <a *ngIf="record.value === 600">Aftrekbare premies:</a>
                        </div>
                    </ng-container>
                    <ng-container>
                        <div *ngIf="incomeTaxEntity.aangifte?.box2 !== undefined && berekening.box2?.opbouwInkomen?.saldoAanmerkelijkBelang !== undefined">
                            <a *ngIf="record.value === 700">Inkomen box 2:</a>
                        </div>

                    </ng-container>
                    <ng-container>
                        <div *ngIf="berekening.box3 && berekening.box3 && berekening.box3.opbouwInkomen && berekening.box3.opbouwInkomen.grondslagSparenEnBeleggen !== undefined ||
                                    berekening.box3 && berekening.box3.opbouwInkomen && berekening.box3.opbouwInkomen.rendementsGrondslag !== undefined">
                            <a *ngIf="record.value === 800">Grondslag box 3: </a>
                        </div>
                    </ng-container>
                    <ng-container>
                        <div *ngIf="incomeTaxEntity.aangifte?.persoonsgebondenAftrek !== undefined">
                            <a *ngIf="record.value === 900">Persoonsgebonden aftrek:</a>
                        </div>
                    </ng-container>
                    <ng-container>
                        <div *ngIf="incomeTaxEntity.aangifte?.voorheffingen !== undefined || (incomeTaxEntity.aangifte?.partnerAangifte && incomeTaxEntity.aangifte?.partnerAangifte?.voorheffingen !== undefined) ||
                        incomeTaxEntity.aangifte?.verliescompensatie !== undefined || (incomeTaxEntity.aangifte?.partnerAangifte && incomeTaxEntity.aangifte?.partnerAangifte?.verliescompensatie !== undefined)">
                            <a *ngIf="record.value === 1100">Voorheffingen:</a>
                        </div>
                    </ng-container>

                    <div *ngIf="record.value === 1200" style="font-weight: bold">
                        <div *ngIf="berekening.partnerBerekening === undefined">
                            <a *ngIf="(sumAanslagenIbenZvw ? sumAanslagenIbenZvw : 0) < 0"
                            >Te ontvangen:</a>
                            <a *ngIf="(sumAanslagenIbenZvw ? sumAanslagenIbenZvw : 0) >= 0"
                            >Te betalen:</a>
                        </div>
                        <div *ngIf="berekening.partnerBerekening !== undefined && berekening.partnerBerekening!.verschuldigdeInkomstenbelasting !== undefined">
                            <a *ngIf="(sumAanslagenIbenZvw ? sumAanslagenIbenZvw : 0) < 0 &&
                            (sumAanslagenIbenZvwPartner ?? 0) < 0"
                            >Te ontvangen:</a>
                            <a *ngIf="(sumAanslagenIbenZvw ? sumAanslagenIbenZvw : 0) >= 0 &&
                            (sumAanslagenIbenZvwPartner ?? 0) >= 0"
                            >Te betalen:</a>
                            <a *ngIf="(sumAanslagenIbenZvw ? sumAanslagenIbenZvw : 0) < 0 &&
                            (sumAanslagenIbenZvwPartner ?? 0) >= 0"
                            >Te ontvangen resp. te betalen:</a>
                            <a *ngIf="(sumAanslagenIbenZvw ? sumAanslagenIbenZvw : 0) >= 0 &&
                            (sumAanslagenIbenZvwPartner ?? 0) < 0"
                            >Te betalen resp. te ontvangen:</a>
                        </div>

                    </div>

                </ng-template>
            </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>

        <snelstart-ui-table-col [showFilter]="false" [showSort]="false" columnType="currency" name="berekeningAangever"
                                width="200px">
            <snelstart-ui-table-col-header>
                <div style="font-size: 13px; color: #00200b ">
                    {{ "Aangever" }}
                </div>
            </snelstart-ui-table-col-header>

            <snelstart-ui-table-col-data>
                <ng-template let-record="record">
                    <ng-container>
                        <a *ngIf="record.value === 200">{{ berekening.box1?.opbouwInkomen?.winstUitOnderneming?.toLocaleString() ?? '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 300">{{ berekening.box1?.opbouwInkomen?.belastbaarloon?.toLocaleString() ?? '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 400">{{ sumOverigInkomen > 0 ? sumOverigInkomen.toLocaleString() : '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 500">{{ sumEigenWoningAangever !== 0 ? sumEigenWoningAangever.toLocaleString() : '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 600">{{ sumPremiesInkomensvoorzieningen > 0 ? (sumPremiesInkomensvoorzieningen * -1).toLocaleString() : '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 700">{{ sumBox2Aangever > 0 ? sumBox2Aangever.toLocaleString() : '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 800">{{
                                berekening.box3?.opbouwInkomen?.grondslagSparenEnBeleggen !== undefined &&
                                berekening.box3?.opbouwInkomen?.grondslagNaVerdeling! > 0 ? berekening.box3?.opbouwInkomen?.grondslagNaVerdeling?.toLocaleString() : ''
                            }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 900">{{ sumPGAAangever > 0 ? (sumPGAAangever * -1).toLocaleString() : '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 1100">{{ sumVoorheffingen != 0 ? (sumVoorheffingen * -1).toLocaleString() : '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 1200"><b>{{ sumAanslagenIbenZvw.toLocaleString() || '' }}</b></a>
                    </ng-container>
                </ng-template>

            </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>

        <snelstart-ui-table-col [showFilter]="false" [showSort]="false" columnType="currency" name="partnerBerekening"
                                width="200px">

            <snelstart-ui-table-col-header>
                <div *ngIf="incomeTaxEntity.aangifte?.gezamenlijkeAangifte !== undefined && incomeTaxEntity.aangifte?.gezamenlijkeAangifte"
                     style="font-size: 13px; color: #00200b ">
                    {{ "Partner" }}
                </div>
                <div *ngIf="incomeTaxEntity.aangifte?.gezamenlijkeAangifte === undefined || !incomeTaxEntity.aangifte?.gezamenlijkeAangifte"
                     style="font-size: 13px; color: #00200b ">
                    {{ "" }}
                </div>
            </snelstart-ui-table-col-header>

            <snelstart-ui-table-col-data>
                <ng-template let-record="record">
                    <ng-container>
                        <a *ngIf="record.value === 200">
                            {{ berekening.partnerBerekening?.box1?.opbouwInkomen?.winstUitOnderneming?.toLocaleString() ?? '' }}
                        </a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 300 && incomeTaxEntity.aangifte?.partnerAangifte && incomeTaxEntity.aangifte?.partnerAangifte?.box1 && incomeTaxEntity.aangifte?.partnerAangifte?.box1?.belastbaarLoon && berekening?.partnerBerekening?.box1?.opbouwInkomen?.belastbaarloon">
                            {{ berekening.partnerBerekening?.box1?.opbouwInkomen?.belastbaarloon?.toLocaleString() }}
                        </a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 400">{{ sumOverigInkomenPartner !== 0 ? sumOverigInkomenPartner.toLocaleString() : '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 500">{{ sumEigenWoningPartner !== 0 ? sumEigenWoningPartner.toLocaleString() : '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 600">{{ sumPremiesInkomensvoorzieningenPartner !== 0 ? (sumPremiesInkomensvoorzieningenPartner * -1).toLocaleString() : '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 700">{{ sumBox2Partner > 0 ? sumBox2Partner.toLocaleString() : '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 800">{{
                                berekening.box3?.opbouwInkomen?.grondslagSparenEnBeleggen !== undefined &&
                                berekening.partnerBerekening?.box3?.opbouwInkomen?.grondslagNaVerdeling! > 0 ? berekening.partnerBerekening?.box3?.opbouwInkomen?.grondslagNaVerdeling?.toLocaleString() : ''
                            }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 900">{{ sumPGAPartner > 0 ? (sumPGAPartner * -1).toLocaleString() : '' }}</a>
                    </ng-container>
                    <ng-container>
                        <a *ngIf="record.value === 1100">{{ sumVoorheffingenPartner != 0 ? (sumVoorheffingenPartner * -1).toLocaleString() : '' }}</a>
                    </ng-container>
                    <ng-container>
                        <div *ngIf="this.incomeTaxEntity.aangifte?.gezamenlijkeAangifte !== undefined && incomeTaxEntity.aangifte?.gezamenlijkeAangifte">
                            <a *ngIf="record.value === 1200"><b>{{ sumAanslagenIbenZvwPartner.toLocaleString() || '' }}</b></a>
                        </div>
                    </ng-container>
                </ng-template>
            </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>

    </snelstart-ui-table>

    <snelstart-venture-fiscaal-domain-logic-service [(dialogVisible)]="this.dialogVisible"
                                                    [title]="'Nieuwe aangifte inkomstenbelasting aanmaken'"
    >
    </snelstart-venture-fiscaal-domain-logic-service>
}
